<template>
  <div class="container">
    <div class="row">
      <div id="datosEconomicos" class="col-lg-12   back-form">
        <div class="col-lg-12 ">
          <div class="col-lg-12 col-md-6 " data-wow-delay="0.9s">
            <div class="card shadow" :class="{ 'successful': this.documents.data.ine }">
              <h4 class=" text-orange card-header shadow">Identificación oficial</h4>
              <div class="card-body row ">
                <div class=" col-lg-4 text-center">
                  <img src="../../../images/icons/ine-front - copia.png" width="150px">
                </div>
                <div class="col-lg-4 text-center pt-4">
                  <!-- <label class="col-12 heding">INE Frontal</label> -->
                  <button type="button" class="theme_btn" style="cursor: pointer;"
                    v-on:click="onPickFile('ine')">INE Frontal</button>
                  <input type="file" style="display: none" ref="fileInputINE" accept="image/*,.pdf,.doc"
                    @change="onFilePicked($event, 'ine')" />
                </div>
                <div class="col-lg-4 text-center pt-4">
                  <!-- <label class="col-12 heding">INE Reverso</label> -->
                  <button type="button" class="theme_btn" style="cursor: pointer;"
                    v-on:click="onPickFile('ine2')">INE Reverso</button>
                  <input type="file" style="display: none" ref="fileInputINE2" accept="image/*,.pdf,.doc"
                    @change="onFilePicked($event, 'ine2')" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-md-6  my-3" data-wow-delay="0.5s">
            <div class="card shadow col-lg-12 col-md-6" :class="{ 'successful': this.documents.data.domicilio }">
              <div class="card-header shadow row">
                <h4 class="text-orange col-lg-11 col-md-5 ">Comprobante de domicilio</h4>
                <div class="col-lg-1 col-md-1 text-right">
                    <button class="btn btn-primary-outline" style="cursor: pointer;"
                    v-on:click="modalInfo('Comprobante de domicilio','Documento que comprueba tu residencia o el domicilio en el que vives actualmente.');">
                    <img src="../../../images/icons/info.png" width="30px">
                  </button>
                </div>
              </div>
              <div class="card-body row mr-5">
                <div class="col-lg-4 text-center ">
                  <img src="../../../images/icons/CFE - copia.png" width="120px">
                </div>
                <div class="col-lg-8 text-center pt-4">
                  <!-- <label class="col-12">Documento que comprueba tu residencia o el domicilio en el que vives
                    actualmente.</label>-->
                  <button type="button" class="theme_btn" style="cursor: pointer;"
                    v-on:click="onPickFile('domicilio')">Adjuntar documento</button>
                  <input type="file" style="display: none" ref="fileInputDomicilio" accept="image/*,.pdf,.doc"
                    @change="onFilePicked($event, 'domicilio')" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-md-6  my-3" data-wow-delay="0.8s">
            <div class="card shadow col-lg-12 col-md-6" :class="{ 'successful': this.documents.data.ingreso }">
              <div class="card-header shadow row">
                <h4 class="text-orange col-lg-11 col-md-5 ">Comprobante de ingresos</h4>
                <div class="col-lg-1 col-md-1 text-right">
                  <button class="btn btn-primary-outline" style="cursor: pointer;"
                    v-on:click="modalInfo('Comprobante de domicilio', 'Documentos formales donde se evidencie que tienes una fuente de ingresos estabele durante 3 meses');">
                    <img src="../../../images/icons/info.png" width="30px">
                  </button>
                </div>
              </div>
              <div class="card-body row ">
                <!-- <label class="offset-4 col-9  ">Documento formal donde se evidencie que tienes una fuente de ingresos
                  regular.</label>-->
                <div class="col-lg-3 text-center">
                  <img src="../../../images/icons/nomina.png" alt="">
                </div>
                <div class="col-lg-3 text-center pt-4">
                  <button type="button" class="theme_btn" style="cursor: pointer;"
                    v-on:click="onPickFile('ingreso1')">Adjuntar documento 1</button>
                  <input type="file" style="display: none" ref="fileInputIngreso1" accept="image/*,.pdf,.doc"
                    @change="onFilePicked($event, 'ingreso1')" />
                </div>
                <div class="col-lg-3 text-center  pt-4">
                  <button type="button" class="theme_btn" style="cursor: pointer;"
                    v-on:click="onPickFile('ingreso2')">Adjuntar documento 2</button>
                  <input type="file" style="display: none" ref="fileInputIngreso2" accept="image/*,.pdf,.doc"
                    @change="onFilePicked($event, 'ingreso2')" />
                </div>
                <div class="col-lg-3 text-center  pt-4">
                  <button type="button" class="theme_btn" style="cursor: pointer;"
                    v-on:click="onPickFile('ingreso3')">Adjuntar documento 3</button>
                  <input type="file" style="display: none" ref="fileInputIngreso3" accept="image/*,.pdf,.doc"
                    @change="onFilePicked($event, 'ingreso3')" />
                </div>

              </div>
            </div>
          </div>
        </div>
        <br>
        <div class="col-lg-12 scroll-step ">
          <button class="theme_btn btn btn-block" v-on:click="saveReference()">Siguiente</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import Environments from '../../environments/Environment';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const numberMask = createNumberMask({
  prefix: '',
  includeThousandsSeparator: true,
  allowNegative: false,
});

export default {
  name: 'Reference',
  data() {
    return {
      TASA: Environments.TASA,
      GPS: Environments.GPS,
      SEGURODEUDOR: Environments.SEGURODEUDOR,
      numberMask,
      models: [],
      brands: [],
      versions: [],
      descriptions: [],
      porcentaje: 0,
      clickupTaskId: '',
      userData: {
        data: {
          a_step: ''
        }
      },
      referenceData: {
        data: {
          name: '',
          phone: '',
          type: '',
        },
        data1: {
          name: '',
          phone: '',
          type: '',
        },
        data2: {
          name: '',
          phone: '',
          type: '',
        },
      },
      documents: {
        data: {
          clickupTaskId: '',
          ine: '',
          ingreso: '',
          domicilio: ''
        }
      },
      detailsData: {
        data: {
          comment: ''
        }
      }
    }
  },
  validations() {
    return {
      referenceData: {
        data: {
          name: { required },
          phone: { required, minValue: minLength(10), maxValue: maxLength(10), $lazy: true }
        },
        data1: {
          name: { required },
          phone: { required, minValue: minLength(10), maxValue: maxLength(10), $lazy: true }
        },
        data2: {
          name: { required },
          phone: { required, minValue: minLength(10), maxValue: maxLength(10), $lazy: true }
        }
      },
    }
  },
  methods: {
    getReference() {
      this.$UserService.getReference().then((result) => {
        if (result.data.length > 0) {
          this.referenceData.data1.name = result.data[0].name;
          this.referenceData.data1.phone = result.data[0].phone;
          this.referenceData.data1.type = result.data[0].type;
        }
        if (result.data.length >= 2) {
          this.referenceData.data2.name = result.data[1].name;
          this.referenceData.data2.phone = result.data[1].phone;
          this.referenceData.data2.type = result.data[1].type;
        }
        if (result.data.length >= 3) {
          this.referenceData.data.name = result.data[2].name;
          this.referenceData.data.phone = result.data[2].phone;
          this.referenceData.data.type = result.data[2].type;
        }
        setTimeout(() => {
          ;
          $('#type_reference1').val(this.referenceData.data1.type);
          $('#type_reference1').niceSelect('update');
          $('#type_reference2').val(this.referenceData.data2.type);
          $('#type_reference2').niceSelect('update');
          $('#type_reference').val(this.referenceData.data.type);
          $('#type_reference').niceSelect('update');
        }, 300);
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    getDocuments() {
      this.$UserService.getDocuments().then((result) => {

        if (result.data.length > 0) {
          this.documents.data.clickup_task = this.clickupTaskId
          this.documents.data.ine = result.data[0].ine;
          this.documents.data.ingreso = result.data[0].ingreso;
          this.documents.data.domicilio = result.data[0].domicilio;

        }
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    getDetails() {
      this.$UserService.getDetails().then((result) => {
        if (result.data.length > 0) {
          this.detailsData.data.comment = result.data[0].comment;
        }
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    saveReference() {
      this.preloader();
      this.userData.data.a_step = 10;
      this.$UserService.updateUser(this.userData)
        .then((result) => {
          this.referenceData.data1.type = $('#type_reference1').val();
          this.referenceData.data2.type = $('#type_reference2').val();
          this.referenceData.data.type = $('#type_reference').val();

          this.$UserService.updateReference({ data: this.referenceData.data1 }).then((result) => {
            this.$UserService.updateReference({ data: this.referenceData.data2 }).then((result) => {
              this.$UserService.updateReference({ data: this.referenceData.data }).then((result) => {
                this.preloaderHiden();
                this.$swal.fire({
                  title: '¡Gracias!',
                  input: 'textarea',
                  inputLabel: "Con esta información nos ayudas a hacer más rápido tu análisis.",
                  inputPlaceholder: this.detailsData.data.comment ? this.detailsData.data.comment : 'Si consideras que hay algo que debamos saber para entender tu situación por favor escríbelo aquí',
                  inputAttributes: {
                    'aria-label': 'Si consideras que hay algo que debamos saber para entender tu situación por favor escríbelo aquí'
                  },
                  inputValidator: (value) => {
                    this.preloader();
                    this.detailsData.data.comment = value ? value : this.detailsData.data.comment;
                    this.$UserService.updateDetails(this.detailsData).then((result) => {
                      this.$UserService.uploapFileUserDataToClickUp().then((result) => {
                        window.location = '/pre-approval';
                        this.preloaderHiden();
                      }, (err) => { this.$swal("¡Cuidado!", 'No se envio la información completa a clickup  <br>' + err.msg, 'warning'); this.preloaderHiden(); });
                    }, (err) => { this.$swal("¡Cuidado!", 'Se requiere completar los campos requeridos de detalle  <br>' + err.msg, 'warning'); this.preloaderHiden(); });
                  }
                });
              }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
            }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
          }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
        }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    onPickFile(name) {
      switch (name) {
        case 'ine':
          this.$refs.fileInputINE.click();
          break;
        case 'ine2':
          this.$refs.fileInputINE2.click();
          break;
        case 'fill_ine':
          this.$refs.fileInputFillIne.click();
          break;
        case 'domicilio':
          this.$refs.fileInputDomicilio.click();
          break;
        case 'ingreso1':
          this.$refs.fileInputIngreso1.click();
          break;
        case 'ingreso2':
          this.$refs.fileInputIngreso2.click();
          break;
        case 'ingreso3':
          this.$refs.fileInputIngreso3.click();
          break;
        default:
          this.$swal("CUIDADO!", 'onPickFile no cuenta con esta opcion:' + name, 'error');
      }
    },
    onFilePicked(event, filename) {
      this.preloader();
      var target = event.target;
      var parent = target.parentElement;
      var data = {
        data: {
          clickupTaskId: this.clickupTaskId,
          files: { file: event.target.files[0], name: filename }
        }
      };
      this.$UserService.getUser().then((resultUser) => {
        data.data.clickupTaskId = resultUser.data[0].clickup_task;
        this.$UserService.uploapFileToClickUp(data).then((result) => {
          if (result.data.status == 0) {
            parent.parentElement.parentElement.classList.add('error');
            parent.parentElement.parentElement.classList.remove('successful');
            this.$swal("CUIDADO!", result.data.msg, 'error');
            this.preloaderHiden();
          } else {
            this.documents.data[filename] = 'true';
            this.$swal("Documento envíado", "Sí tienes mas archivos por enviar, repite el proceso.", 'success');
            this.preloaderHiden();
          }
        }, (err) => {
          parent.parentElement.parentElement.classList.add('error');
          parent.parentElement.parentElement.classList.remove('successful');
          this.$swal("CUIDADO!", "Tenemos un problema para subir su archivo " + err.msg, 'error');
          this.preloaderHiden();
        });
      }, (err) => { this.$swal("CUIDADO!", "getUser " + err.msg, 'error'); this.preloaderHiden(); });
    },
    modalInfo(title, message) {
      this.$swal(title, message, "info");
    },
    preloader() {
      $('.preloader').fadeIn();
      $('.preloader').delay(10).fadeIn('slow');
    },
    preloaderHiden() {
      $('.preloader').fadeOut();
      $('.preloader').delay(10).fadeOut('slow');
    }
  },
  created() {
    this.getDocuments();
    this.getReference();
    this.getDetails();
    window.scrollTo(0, 0);
  },
}
</script>

<style lang="scss">
.error {
  border-color: red !important;
  background: #FDD;
}

.successful {
  -webkit-box-shadow: 5px 5px 10px rgba(0, 160, 133, 0.7) !important;
  -moz-box-shadow: 5px 65px 10px rgba(0, 160, 133, 0.7) !important;
  box-shadow: 5px 5px 10dpx rgba(0, 160, 133, 0.7) !important;
}

.error:focus {
  outline-color: #F99;
}

.text-orange {
  color: rgb(245, 144, 25);
  font-weight: bold;
}

.nice-select .current {
  width: -webkit-fill-available !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.shadow {
  box-shadow: 10px 10px 40px
    /* Sombra con un desenfoque casi disipado */
}
</style>



// WEBPACK FOOTER //
// src/views/GrayZone/Reference.vue